import { isAdminUserDetailResponse, isAdminUsersListResponse, } from '@urbanik/api-contracts';
export class AdminUsersApiError extends Error {
    kind;
    constructor(kind, message) {
        super(message);
        this.kind = kind;
        this.name = 'AdminUsersApiError';
    }
}
async function request(url, init) {
    try {
        return await fetch(url, { ...init, credentials: 'include' });
    }
    catch {
        throw new AdminUsersApiError('unavailable', 'No pudimos conectar con el servidor.');
    }
}
async function problem(response) {
    const payload = (await response.json().catch(() => null));
    const message = payload?.message ?? 'No pudimos completar la operación.';
    if (response.status === 401)
        throw new AdminUsersApiError('unauthorized', message);
    if (response.status === 403)
        throw new AdminUsersApiError('forbidden', message);
    if (response.status === 409)
        throw new AdminUsersApiError('conflict', message);
    if (response.status === 400)
        throw new AdminUsersApiError('validation', message);
    throw new AdminUsersApiError('unavailable', message);
}
export async function getAdminUsers(baseUrl, options, signal) {
    const params = new URLSearchParams();
    if (options.search)
        params.set('search', options.search);
    if (options.status && options.status !== 'all')
        params.set('status', options.status);
    params.set('page', String(options.page ?? 1));
    params.set('pageSize', String(options.pageSize ?? 10));
    const response = await request(`${baseUrl.replace(/\/$/, '')}/identity/users?${params}`, {
        headers: { Accept: 'application/json' },
        signal: signal ?? null,
    });
    if (!response.ok)
        return problem(response);
    const payload = await response.json();
    if (!isAdminUsersListResponse(payload))
        throw new AdminUsersApiError('unavailable', 'La respuesta de usuarios no es válida.');
    return payload;
}
export async function getAdminUser(baseUrl, userId) {
    const response = await request(`${baseUrl.replace(/\/$/, '')}/identity/users/${encodeURIComponent(userId)}`, { headers: { Accept: 'application/json' } });
    if (!response.ok)
        return problem(response);
    const payload = await response.json();
    if (!isAdminUserDetailResponse(payload))
        throw new AdminUsersApiError('unavailable', 'El detalle de usuario no es válido.');
    return payload;
}
export async function createAdminUser(baseUrl, input) {
    const response = await request(`${baseUrl.replace(/\/$/, '')}/identity/users`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(input),
    });
    if (!response.ok)
        return problem(response);
    const payload = await response.json();
    if (!isAdminUserDetailResponse(payload))
        throw new AdminUsersApiError('unavailable', 'La cuenta creada no es válida.');
    return payload;
}
export async function changeAdminUserStatus(baseUrl, userId, input) {
    const response = await request(`${baseUrl.replace(/\/$/, '')}/identity/users/${encodeURIComponent(userId)}/status`, {
        method: 'PATCH',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(input),
    });
    if (!response.ok)
        return problem(response);
    const payload = await response.json();
    if (!isAdminUserDetailResponse(payload))
        throw new AdminUsersApiError('unavailable', 'El estado actualizado no es válido.');
    return payload;
}
